module.exports = "<p>\n  loginadmin works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loginadmin/loginadmin.component.html
// module id = ./src/app/components/loginadmin/loginadmin.component.html
// module chunks = main